const brlNumberFormatter = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Formata dígitos (centavos) para exibição pt-BR: 1 → 0,01; 100000 → 1.000,00 */
export function maskMoneyInput(raw: string): string {
  const digits = raw.replace(/\D/g, "");
  if (digits === "") return "";
  const cents = parseInt(digits, 10);
  if (!Number.isFinite(cents)) return "";
  return brlNumberFormatter.format(cents / 100);
}

/** Converte valor mascarado ou dígitos para número (reais). */
export function parseMoneyMask(masked: string): number {
  const digits = masked.replace(/\D/g, "");
  if (digits === "") return 0;
  const cents = parseInt(digits, 10);
  if (!Number.isFinite(cents)) return 0;
  return cents / 100;
}

/** Converte número para string mascarada pt-BR. */
export function numberToMoneyMask(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "";
  return maskMoneyInput(String(Math.round(Math.abs(value) * 100)));
}
